module.exports = __webpack_public_path__ + "img/zphd_icon_silver.ea07868d.png";